import { PowertrainService } from "./../services/powertrain.service";
import { AuthService } from "./../services/auth.service";
import { StockService } from "./../services/stock.service";
import { SpareInOutService } from "../service/spare-in-out.service";
import { MessageService } from "../services/message.service";
import { Message } from "../common/message";
import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { SpareInOut } from "../models/spareinout";
import { SparepartService } from "../services/sparepart.service";

@Component({
  selector: "app-spare-parts-in-out",
  templateUrl: "./spare-parts-in-out.component.html",
  styleUrls: ["./spare-parts-in-out.component.scss"],
})
export class SparePartsInOutComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  @Input() isInventory: boolean;

  form: FormGroup;
  submitted = false;
  success = false;

  isAddNew: boolean = true;
  stocks: any;
  stocksFrom: any;
  stocksTo: any;
  items: any;
  resource: SpareInOut = new SpareInOut();
  powerTrains: any[];
  engines: any[];
  data: any[];
  credit = 0;
  aboGhates = "621f26a32ca9250018375095";
  french = "5d5dc40e06521f510ca6de44";
  spain = "5d5dc41b06521f510ca6de45";
  sleep = "5d9e6422f6509d001799d4e1";
  main = "5d5dc40206521f510ca6de43";
  govParty = "5d9f192331a1190017cd4aee";
  interPlusCompany = "5d9db132234c8b3f780fae86";
  mhatetMisr: string = "63eca16f52e4d000161ff624";

  constructor(
    private dialog: MatDialog,
    private stockService: StockService,
    private spService: SparepartService,
    private service: SpareInOutService,
    private formBuilder: FormBuilder,
    private msg: MessageService,
    private ptService: PowertrainService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.setMessageForm();
    this.getStocks();
    this.getItems();
    this.getPowertrains();
  }

  getPowertrains() {
    this.powerTrains = [];
    this.engines = [];
    this.ptService.getAll().subscribe((result) => {
      this.powerTrains = this.powerTrains.concat(result);
    });
  }

  onPowerTrainChange(pt) {
    for (var obj of this.powerTrains) {
      if (obj.id == pt) {
        if (obj && obj.motors && obj.motors.length) {
          this.engines = obj.motors;
          this.resource.motorId = null;
          return;
        } else {
          this.engines = [];
          this.resource.motorId = null;
          return;
        }
      }
    }
    this.engines = [];
    this.resource.motorId = null;
  }

  getStocks() {
    this.stocks = [];
    this.stockService.getAll().subscribe((result) => {
      this.stocks = this.stocks.concat(result);
    });
  }

  isAddParty() {
    for (let s of this.getAddedParty()) {
      if (s.id == this.resource.from) {
        return true;
      }
    }
    return false;
  }

  isProvidedParty() {
    for (let s of this.getProvidedParty()) {
      if (s.id == this.resource.from) {
        return true;
      }
    }
    return false;
  }

  getProvidedParty() {
    let list = [];
    for (var s of this.stocks) {
      if (s.id == this.govParty || s.id == this.interPlusCompany) {
        list.push(s);
      }
    }
    return list;
  }

  getAddedParty() {
    let list = [];
    if (this.type == "in") {
      return this.getProvidedParty();
    } else {
      return this.getInParty();
    }
  }

  getInParty() {
    let list = [];
    for (var s of this.stocks) {
      if (s.id != this.govParty && s.id != this.interPlusCompany) {
        list.push(s);
      }
    }

    return list;
  }

  showPtAndEngine() {
    return (
      this.type == "out" &&
      (!this.resource.to || this.resource.to == "null") &&
      !this.isAddMainStore()
    );
  }

  isAddMainStore() {
    if (this.resource.from == this.main) return true;
    else return false;
  }

  getItems() {
    this.items = [];
    this.spService.getAll().subscribe((result) => {
      this.items = this.items.concat(result);
    });
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      from: ["", Validators.required],
      to: ["", Validators.required],
      item: ["", Validators.required],
      qty: ["", Validators.required],
      reason: ["", Validators.required],
      powertrainId: ["", Validators.required],
      motorId: ["", Validators.required],
    });
  }

  onSave() {
    this.submitted = true;

    if (!this.resource) {
      return;
    }

    if (!this.resource.from || this.resource.from.trim() == "") {
      return;
    }

    if (!this.resource.item || this.resource.item.trim() == "") {
      return;
    }

    if (!this.resource.qty) {
      this.msg.alert(Message.MUST_BE_MORE_THAN_ZARO);
      return;
    }

    if (this.resource.qty && this.resource.qty <= 0) {
      this.msg.alert(Message.MUST_BE_MORE_THAN_ZARO);
      return;
    }

    // if (
    //   this.type == "out" &&
    //   this.resource.qty &&
    //   this.resource.qty > this.credit
    // ) {
    //   this.msg.alert(Message.CREDIT_NOT_ENOUGH);
    //   return;
    // }

    if (!this.resource.to || this.resource.to == "null") {
      if (this.isAddMainStore() || this.isProvidedParty()) {
        this.msg.alert(Message.MUST_ADD_TO);
        return;
      }

      if (
        this.resource.powerTrainId == null ||
        this.resource.motorId == null ||
        this.resource.powerTrainId == "null" ||
        this.resource.motorId == "null"
      ) {
        this.msg.alert(Message.MUST_SELECT_POWERCOACH);
        return;
      }
    }

    this.addElement();
  }

  // getItemCredit(item: string) {
  //   if (this.type == "in" || item == null || item == "null") return;
  //   if (!item || item == "null") {
  //     this.credit = 0;
  //     return;
  //   }
  //   this.getResources(item);
  // }

  selectFrom() {
    this.resource.item = null;
    this.credit = 0;
    this.resource.setQty(0);
  }

  selectTo() {
    this.resource.setMotorId(null);
    this.resource.setPowerTrainId(null);
  }

  onItemSelect(item: string) {
    this.resource.item = item ? item : null;

    // if (!this.resource.item) {
    //   this.data = [];
    //   return;
    // }

    // let arr = this.data;

    // if (!this.data || !this.data.length) {
    //   this.credit = 0;
    //   return;
    // }

    // if (this.resource.from == this.main) {
    //   this.credit = this.getMainQty(arr);
    //   return;
    // }

    // if (this.resource.from == this.spain) {
    //   this.credit = this.getSpainQty(arr);
    //   return;
    // }

    // if (this.resource.from == this.french) {
    //   this.credit = this.getFrenchQty(arr);
    //   return;
    // }

    // if (this.resource.from == this.aboGhates) {
    //   this.credit = this.getAboGhatesQty(arr);
    //   return;
    // }

    // if (this.resource.from == this.sleep) {
    //   this.credit = this.getSleepQty(arr);
    //   return;
    // }

    // if (this.resource.from == this.mhatetMisr) {
    //   this.credit = this.getMhtetMisrQty(arr);
    //   return;
    // }
  }

  // getMainQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.main) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.main) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getSpainQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.spain) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.spain) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getAboGhatesQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.aboGhates) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.aboGhates) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getFrenchQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.french) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.french) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getSleepQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.sleep) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.sleep) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getMhtetMisrQty(list: any) {
  //   let qty = 0;
  //   for (let i of list) {
  //     if (i.to && i.to == this.mhatetMisr) {
  //       qty += i.qty;
  //     }
  //     if (i.from == this.mhatetMisr) {
  //       qty -= i.qty;
  //     }
  //   }
  //   return qty;
  // }

  // getResources(itemId) {
  //   this.data = [];
  //   this.service.getAllResources(itemId).subscribe((result) => {
  //     this.data = this.data.concat(result);
  //     //get the quantities
  //     this.onItemSelect(itemId);
  //   });
  // }

  resetForm(ret?: boolean) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    this.credit = 0;
  }

  addElement() {
    this.resource.setType(this.type);
    if (this.isInventory) this.resource.setReason("init");
    this.service.create(this.resource).subscribe((result: any) => {
      this.msg.alert(Message.SAVE);
      this.resetForm();
    });
  }

  goHome() {
    this.authService.goLogin();
  }
}
